import { addDays, parseYmd } from './time';

export const HIJRI_MONTHS = [
  'Muharram', 'Safar', 'Rabi al-Awwal', 'Rabi al-Thani', 'Jumada I', 'Jumada II',
  'Rajab', 'Sha‘ban', 'Ramadan', 'Shawwal', 'Dhul Qa‘dah', 'Dhul Hijjah',
] as const;

let hijriFmt: Intl.DateTimeFormat | null = null;
function fmt() {
  hijriFmt ??= new Intl.DateTimeFormat('en-u-ca-islamic-umalqura-nu-latn', { timeZone: 'UTC', day: 'numeric', month: 'numeric', year: 'numeric' });
  return hijriFmt;
}

export interface HijriDate { day: number; month: number; year: number; monthName: string }

/** Hijri date (Umm al-Qura) for a civil date, shifted by the masjid's moon-sighting adjustment. */
export function hijriFor(day: string, adjust = 0): HijriDate {
  const shifted = addDays(day, Math.max(-3, Math.min(3, Math.round(adjust))));
  const { year, month, day: d } = parseYmd(shifted);
  const parts: Record<string, string> = {};
  for (const p of fmt().formatToParts(new Date(Date.UTC(year, month - 1, d, 12)))) parts[p.type] = p.value;
  const m = Math.min(12, Math.max(1, parseInt(parts.month ?? '1', 10)));
  return { day: parseInt(parts.day ?? '1', 10), month: m, year: parseInt((parts.year ?? '0').replace(/\D/g, ''), 10), monthName: HIJRI_MONTHS[m - 1]! };
}

export const formatHijri = (h: HijriDate) => `${h.day} ${h.monthName} ${h.year}`;
